import { render, staticRenderFns } from "./electronicWallets.vue?vue&type=template&id=1456bb9f"
import script from "./electronicWallets.vue?vue&type=script&lang=js"
export * from "./electronicWallets.vue?vue&type=script&lang=js"
import style0 from "./electronicWallets.vue?vue&type=style&index=0&id=1456bb9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports